const s = {
  name: "PhilippinePeso",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M15,11h5c2.1,0,3.8,1.2,4.6,3H27v2h-2v1h2v2h-2.4c-0.8,1.8-2.5,3-4.6,3h-3v7h-2V19h-2v-2h2v-1h-2v-2h2V11z
			 M17,19v1h3c0.9,0,1.7-0.4,2.2-1H17z M23,17v-1h-6v1H23z M20,13h-3v1h5.2C21.7,13.4,20.9,13,20,13z"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20s-9,20-20,20C9,40,0,31,0,20z M20,2C10.1,2,2,10.1,2,20s8.1,18,18,18
			c9.9,0,18-8.1,18-18S29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as PhilippinePeso
};
